import { useEffect, useRef } from 'react';
import {
  createMap,
  mapOptionSelector,
  clearMap,
  addAllDataToMap,
  filterDataTimeFrame,
} from '../lib/mapUtils.js';

/**
 * Full all-runs map: draws every activity polyline with popups + click
 * highlight, and redraws when `timeFrame` (a "y.m.d.h" filter string) changes.
 */
export default function AllRunsMap({ data, timeFrame = '', id = 'allRunsMap', style }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return undefined;
    const map = createMap(containerRef.current, mapOptionSelector('allRuns'));
    mapRef.current = map;
    // Container is sized via CSS (vh/inherit); make sure Leaflet measures it.
    const t = setTimeout(() => map.invalidateSize(), 0);
    return () => {
      clearTimeout(t);
      map.remove();
      mapRef.current = null;
    };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    map.off('click');
    clearMap(map);
    addAllDataToMap(map, filterDataTimeFrame(data, timeFrame));
  }, [data, timeFrame]);

  return <div ref={containerRef} id={id} style={style} />;
}
